import * as actions from 'actions/dashboard';

export const initialState = {
    areas: [],
    businessUnits: [],
    coaches: [],
    competencies: [],
    courses: [],
    departments: [],
    downline: true,
    goals: [],
    homeWhatsHappening: {
        show: '',
        data: [],
    },
    languages: [],
    leaderboard: {
        loading: true,
        report: null,
    },
    locations: [],
    metrics: [],
    profiles: [],
    roles: [],
    teams: [],
    team: null,
};

export const dashboardState = (state = initialState, action) => {
    switch (action.type) {
        case actions.SET_DASHBOARD_COLLECTION: {
            switch (action.payload.collection) {
                case 'areas':
                    return { ...state, areas: action.payload.array };
                case 'coaches':
                    return { ...state, coaches: action.payload.array };
                case 'competencies':
                    return { ...state, competencies: action.payload.array };
                case 'courses':
                    return { ...state, courses: action.payload.array };
                case 'departments':
                    return { ...state, departments: action.payload.array };
                case 'goals':
                    return { ...state, goals: action.payload.array };
                case 'languages':
                    return { ...state, languages: action.payload.array };
                case 'locations':
                    return { ...state, locations: action.payload.array };
                case 'metrics':
                    return { ...state, metrics: action.payload.array };
                case 'pathways':
                    return { ...state, pathways: action.payload.array };
                case 'profiles':
                    return { ...state, profiles: action.payload.array };
                case 'roles':
                    return { ...state, roles: action.payload.array };
                case 'teams':
                    return { ...state, teams: action.payload.array };
                case 'units':
                    return { ...state, businessUnits: action.payload.array };
                default:
                    return state;
            }
        }
        case actions.DASHBOARD_LOADING:
            return { ...state, [action.payload]: { loading: true } };
        case actions.LEADERBOARD_LOADED:
            return { ...state, leaderboard: { loading: false, report: action.payload } };
        case actions.SET_TEAM:
            return { ...state, team: action.payload };
        case actions.SET_DOWNLINE:
            return { ...state, downline: action.payload };
        case actions.HOME_WHATS_HAPPENING:
            return { ...state, homeWhatsHappening: action.payload };

        default:
            return state;
    }
};
